// hooks/useJwtRole.js
import { useEffect, useState } from 'react';
import api from '../utils/api';

function parseJwt(token) {
  try {
    const b = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(atob(b).split('').map(c => `%${('00'+c.charCodeAt(0).toString(16)).slice(-2)}`).join('')));
  } catch { return null; }
}
function readAccessToken() {
  const hdr = api.defaults.headers?.common?.Authorization;
  if (hdr?.startsWith('Bearer ')) return hdr.slice(7);
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') || null;
}

export default function useJwtRole() {
  const [role, setRole] = useState(() => {
    const t = readAccessToken(); return t ? (parseJwt(t)?.role ?? null) : null;
  });

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'accessToken') {
        const t = readAccessToken();
        setRole(t ? (parseJwt(t)?.role ?? null) : null);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return role;
}
